import { forEach } from 'lodash/fp';
import { updateAppConfiguration } from '@mews-commander/data-access';
import { logError } from '../../modules/app/actions/common';
import { prefetchAssets } from '../../modules/app/actions/prefetch';
import { getVersion, isDemo, isProduction } from '../../modules/app/reducers/configuration';
import { isAppPrefetchingNewVersion, isNewAppVersionFetched } from '../../modules/app/reducers/status';
import { connectionEstablished, scheduleAppVersionChangedSnackbar } from '../connection/actions';
import { onOpen } from './actions';
import { getSubscriptions } from './selectors';

export const createOnMessage =
    (messageHandler: $TSFixMe) =>
    (data: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const message = container().apiComponent.normalizeWebSocketResponse(data);
        const { type, assetVersion, versionHash } = message;
        const state = getState();

        dispatch(connectionEstablished());
        updateAppConfiguration({ platformVersion: versionHash });

        const currentAssetVersion = getVersion();
        const hasNewVersion = isNewAppVersionFetched(state);
        const isPrefetching = isAppPrefetchingNewVersion(state);

        // update feature is limited to customer facing environments, local and prerelease branch websocket events return develop asset version
        const isSupportedEnvironment = isDemo() || isProduction();

        const handleNewAssetVersion =
            isSupportedEnvironment &&
            assetVersion &&
            assetVersion !== currentAssetVersion &&
            !hasNewVersion &&
            !isPrefetching;
        if (handleNewAssetVersion) {
            const prefetchStarted = Date.now();
            dispatch(prefetchAssets(assetVersion))
                .then(() => {
                    dispatch(
                        logError({
                            type: 'force-reload',
                            message: 'App version prefetched',
                            context: { assetVersion, duration: Date.now() - prefetchStarted },
                        })
                    );
                })
                .catch((error: $TSFixMe) => {
                    dispatch(
                        logError({
                            type: 'force-reload',
                            message: 'App version failed to prefetch',
                            context: { assetVersion, error },
                        })
                    );
                });

            dispatch(scheduleAppVersionChangedSnackbar());
        }

        messageHandler(type, message, { dispatch, getState });
    };

export const createOnOpen = (subscriptions: $TSFixMe) => () => (dispatch: $TSFixMe, getState: $TSFixMe) => {
    dispatch(onOpen());
    dispatch(connectionEstablished());

    const subscribedKeys = getSubscriptions(getState());
    forEach((subscription) => {
        dispatch(subscriptions[subscription]());
    }, subscribedKeys);
};
